import React, { useEffect, useState } from 'react'
import { Card, CardBody, CardTitle, Col, Form, FormFeedback, Row, Button, Label, Input, UncontrolledTooltip } from 'reactstrap';
import Breadcrumb from 'components/Common/Breadcrumb';
import { useFormik } from 'formik';
import * as Yup from "yup";
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { getSettings, settingsUpdate } from 'store/actions';
import AuthLoader from 'components/Common/AuthLoader';
import { Link } from 'react-router-dom';

const Settings = () => {
    document.title = "Settings | Glottis Logistics";
    const dispatch = useDispatch()
    const [settingsData, setSettingsData] = useState([])
    const [settingsEdit, setSettingsEdit] = useState(true)
    const [adressEdit, setadressEdit] = useState(true)
    const [settingLoader, setSettingLoader] = useState(false)
    const [addressLoader, setAddressLoader] = useState(false)
    const settings = useSelector(state => ({
        settings: state.GetSettings 
    }), shallowEqual)
    const Loader = useSelector(state => ({
        Loader: state.SettingsUpdate 
    }), shallowEqual)

    useEffect(() => {
        if (settings?.settings?.data) {
            if (settings?.settings?.data?.data) {
                setSettingsData(settings?.settings?.data?.data[0])
            } else {
                setSettingsData([])
            }
        }
    }, [settingsData])
    const settingsForm = useFormik({
        enableReinitialize: true,
        initialValues: {
            email: settingsData?.email || '',
            phoneNumber: settingsData?.phoneNumber || '',
        },
        validationSchema: Yup.object({
            email: Yup.string().email('Enter valid email address').required("Enter email address").max(30, 'Email should not exceed 30 characters'),
            phoneNumber: Yup.string().required("Enter phone number").max(15, 'Phone number should not exceed 15 characters')
        }),
        onSubmit: (values) => {
            const data = {}
            data["_id"] = settingsData._id
            data["email"] = values.email
            data["phoneNumber"] = values.phoneNumber
            data["form"] = 'settings'
            setSettingLoader(true)
            dispatch(settingsUpdate(data, dispatch, getSettings, setSettingsEdit))
        }
    }); 

    const addressForm = useFormik({
        enableReinitialize: true,
        initialValues: {
            toEmail: settingsData?.toEmail || '',
        },
        validationSchema: Yup.object({
            toEmail: Yup.string().email('Enter valid email address').required("Enter TO email address").max(30, 'To email should not exceed 30 characters'),
        }),
        onSubmit: (values) => {
            const data = {}
            data["_id"] = settingsData._id
            data["toEmail"] = values.toEmail
            data["form"] = 'address'
            setAddressLoader(true)
            dispatch(settingsUpdate(data, dispatch, getSettings, setadressEdit))
        }
    }); 

    useEffect(() => {
        if (!Loader?.Loader?.loading) {
            setSettingLoader(false)
            setAddressLoader(false)
        }
    }, [Loader?.Loader?.loading])
    return (
        <div className="page-content settings">
            <div className="container-fluid">
                <Breadcrumb title="Dashboard" dashurl="/dashboard" breadcrumbItem="Settings" />
                <Row className="justify-content-between user-info">
                    <Col lg='6'>
                        <Card color="info" className="text-white-50">
                            <CardBody>
                                <CardTitle className="m-0 text-white">
                                    <i className="mdi mdi-alert-circle-outline me-3" />For any queries/assistance, clients will contact to this below phone number or email address
                                </CardTitle>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col lg='6' className='addressInfo'>
                        <AddressInfo />
                    </Col>
                </Row>
                <Row className="justify-content-between mb-4 user-info">
                    <Col lg="6">
                        <Card>
                            <CardBody>
                                <div className='d-flex justify-content-end'>
                                    <Link to={`#`}
                                        id={"Edit"}
                                        className='d-flex justify-content-center align-items-center settings-action'
                                        onClick={() => setSettingsEdit(!settingsEdit)}
                                    >
                                        <i className={`${!settingsEdit ? 'mdi mdi-close-circle' : 'bx bx-edit-alt'} font-size-16 primary-color`}></i>
                                        <UncontrolledTooltip placement="top" target={"Edit"}>
                                            {!settingsEdit ? 'Click to cancel' : 'Click to edit'}
                                        </UncontrolledTooltip>
                                    </Link>
                                </div>
                                <Form
                                    className="form-horizontal"
                                    onSubmit={(e) => {
                                        e.preventDefault();
                                        settingsForm.handleSubmit();
                                        return false;
                                    }}
                                >
                                    <div className="form-group mb-4">
                                        <Label className="form-label">Enquiry email address<span>*</span></Label>
                                        <Input
                                            name="email"
                                            className="form-control"
                                            type="text"
                                            onChange={settingsForm.handleChange}
                                            onBlur={settingsForm.handleBlur}
                                            value={settingsForm.values.email}
                                            invalid={
                                                settingsForm.touched.email && settingsForm.errors.email ? true : false
                                            }
                                            disabled={settingsEdit}
                                        />
                                        {settingsForm.touched.email && settingsForm.errors.email ? (
                                            <FormFeedback type="invalid">{settingsForm.errors.email}</FormFeedback>
                                        ) : null}
                                    </div>
                                    <div className="form-group mb-4">
                                        <Label className="form-label">Enquiry phone number<span>*</span></Label>
                                        <Input
                                            name="phoneNumber"
                                            className="form-control"
                                            onWheel={(e) => e.target.blur()}
                                            type='number'
                                            onChange={settingsForm.handleChange}
                                            onBlur={settingsForm.handleBlur}
                                            value={settingsForm.values.phoneNumber}
                                            invalid={
                                                settingsForm.touched.phoneNumber && settingsForm.errors.phoneNumber ? true : false
                                            }
                                            disabled={settingsEdit}
                                        />
                                        {settingsForm.touched.phoneNumber && settingsForm.errors.phoneNumber ? (
                                            <FormFeedback type="invalid">{settingsForm.errors.phoneNumber}</FormFeedback>
                                        ) : null}
                                    </div>  
                                    <div className="text-center mt-4">
                                        {settingLoader === true ? <div className='action-btn-loader d-flex justify-content-center'><AuthLoader/></div>:
                                        <Button type="submit" disabled={settingsEdit} className="primary-button">
                                            Save
                                        </Button>}
                                    </div>
                                </Form>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col lg="6">
                        <div className='addressInfo-res'>
                            <AddressInfo />
                        </div>
                        <Card>
                            <CardBody>
                                <div className='d-flex justify-content-end'>
                                    <Link to={`#`}
                                        id={"addressEdit"}
                                        className='d-flex justify-content-center align-items-center settings-action'
                                        onClick={() => setadressEdit(!adressEdit)}
                                    >
                                        <i className={`${!adressEdit ? 'mdi mdi-close-circle' : 'bx bx-edit-alt'} font-size-16 primary-color`}></i>
                                        <UncontrolledTooltip placement="top" target={"addressEdit"}>
                                            {!adressEdit ? 'Click to cancel' : 'Click to edit'}
                                        </UncontrolledTooltip>
                                    </Link>
                                </div>
                                <Form
                                    className="form-horizontal"
                                    onSubmit={(e) => {
                                        e.preventDefault();
                                        addressForm.handleSubmit();
                                        return false;
                                    }}
                                >
                                    <div className="form-group mb-4">
                                        <Label className="form-label">To email address<span>*</span></Label>
                                        <Input
                                            name="toEmail"
                                            className="form-control"
                                            type="text"
                                            onChange={addressForm.handleChange}
                                            onBlur={addressForm.handleBlur}
                                            value={addressForm.values.toEmail}
                                            invalid={
                                                addressForm.touched.toEmail && addressForm.errors.toEmail ? true : false
                                            }
                                            disabled={adressEdit}
                                        />
                                        {addressForm.touched.toEmail && addressForm.errors.toEmail ? (
                                            <FormFeedback type="invalid">{addressForm.errors.toEmail}</FormFeedback>
                                        ) : null}
                                    </div>
                                    <div className="text-center mt-4">
                                        {addressLoader === true ? <div className='action-btn-loader d-flex justify-content-center'><AuthLoader/></div>:
                                            <Button disabled={adressEdit} type="submit" className="primary-button">
                                            Save
                                        </Button>}
                                    </div>
                                </Form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </div>
    )
}

export default Settings

const AddressInfo = () => {
    return <Card color="info" className="text-white-50">
        <CardBody>
            <CardTitle className="m-0 text-white">
                <i className="mdi mdi-alert-circle-outline me-3" />All admin notifications will be sent to given email address
            </CardTitle>
        </CardBody>
    </Card>
}